if (!customElements.get('ms-product-details')) {
  customElements.define('ms-product-details', class extends HTMLElement {
    connectedCallback() {
      this.onVariantChange = async (event) => {
        if (!event.detail.form?.classList.contains('js-product-form-main') || !event.detail.variant) return;
        this.controller?.abort();
        this.controller = new AbortController();
        const url = new URL(this.dataset.productUrl, window.location.origin);
        url.searchParams.set('section_id', this.dataset.sectionId);
        url.searchParams.set('variant', event.detail.variant.id);
        const selectedTab = this.querySelector('[role="tab"][aria-selected="true"]')?.id;
        try {
          const response = await fetch(url, { signal: this.controller.signal });
          if (!response.ok) return;
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const next = doc.querySelector('ms-product-details');
          if (!next) return;
          this.innerHTML = next.innerHTML;
          const tab = selectedTab && Array.from(this.querySelectorAll('[role="tab"]')).find(item => item.id === selectedTab);
          if (tab) this.querySelector('tabbed-content')?.activateTab(tab);
        } catch (error) {
          if (error.name !== 'AbortError') console.error('Product details could not be refreshed.', error);
        }
      };
      document.addEventListener('on:variant:change', this.onVariantChange);
    }
    disconnectedCallback() {
      this.controller?.abort();
      document.removeEventListener('on:variant:change', this.onVariantChange);
    }
  });
}
